import cn from "@/v2-ui/utils/utils.cn"
import Icon from "@/v2-ui/icon"
import type {
  MigrationCenterMemberSort,
  MigrationCenterMemberSortKey,
} from "@/v2-backoffice-client/tenant/migration/center/tenant.migration.center.types"

export type MigrationCenterMemberSortHeaderProps = {
  label: string
  sortKey: MigrationCenterMemberSortKey
  sort: MigrationCenterMemberSort
  onSort(key: MigrationCenterMemberSortKey): void
  className?: string
}

/** One sortable column header of the center's member tables. */
function MigrationCenterMemberSortHeader(
  props: MigrationCenterMemberSortHeaderProps,
) {
  const { label, sortKey, sort, onSort, className } = props
  const active = sort.key === sortKey
  return (
    <th className={cn("px-3 py-1.5 font-medium", className)}>
      <button
        type="button"
        className={cn(
          "inline-flex items-center gap-1 hover:text-foreground",
          active && "text-foreground",
        )}
        data-feature-code="UI_MigrationCenter_MemberSort"
        onClick={() => {
          onSort(sortKey)
        }}
      >
        {label}
        {active && (
          <Icon
            src={sort.desc ? "angle-small-down" : "angle-small-up"}
            size={12}
          />
        )}
      </button>
    </th>
  )
}

export default MigrationCenterMemberSortHeader
